import React, { useContext, useEffect } from "react";
import {ConfigurationStateContext} from "../../store/configurationState/ConfigurationStateProvider"

import { useSearchParams  } from "react-router-dom";
import { ConfigurationStateActionEnum } from "../../store/configurationState/interfaces";
import { tryParseUrl } from "../../utils/commonUtils";
import { useViewerStateStore } from "../../store/viewerStateStore";

const urlParamNames = {
    bimVault: "bimVaultApiUrl",
    threeDee: "threeDeeApiUrl",
    core: "coreApiUrl",
    language: "lang",
    isDebugMode: "kailehtinen"
}

const ConfigurationUrlParamsHandler = () =>
{
    const { configurationState, dispatch } = useContext(ConfigurationStateContext);
    const [ searchParams ] = useSearchParams();
    const { setIsDebugMode } = useViewerStateStore();

    useEffect(() => {
        const bimVaultApiUrl =  tryParseUrl(searchParams.get(urlParamNames.bimVault));
        const threeDeeApiUrl =  tryParseUrl(searchParams.get(urlParamNames.threeDee));
        const coreApiUrl =      tryParseUrl(searchParams.get(urlParamNames.core));
        const language =        searchParams.get(urlParamNames.language);

        const next = { ...configurationState };
        let changed = false;

        if (bimVaultApiUrl && bimVaultApiUrl?.href !== configurationState.bimVaultApiUrl?.href)
        {
            console.info(`Using BimVault API from url params: ${bimVaultApiUrl}`);
            next.bimVaultApiUrl = bimVaultApiUrl;
            changed = true;
        }

        if (threeDeeApiUrl && threeDeeApiUrl?.href !== configurationState.threeDeeApiUrl?.href)
        {
            console.info(`Using ThreeDee API from url params: ${threeDeeApiUrl}`);
            next.threeDeeApiUrl = threeDeeApiUrl;
            changed = true;
        }

        if (coreApiUrl && coreApiUrl?.href !== configurationState.coreApiUrl?.href)
        {
            console.info(`Using Core API from url params: ${coreApiUrl}`);
            next.coreApiUrl = coreApiUrl;
            changed = true;
        }

        if (language && language !== configurationState.preferredLanguage)
        {
            console.info(`Using language from url params: ${language}`);
            next.preferredLanguage = language;
            changed = true;
        }

        const isDebugMode = searchParams.get(urlParamNames.isDebugMode);
        if (isDebugMode)
        {
            console.info(`Using Debug Mode from url params: ${isDebugMode}`);
            setIsDebugMode(true);
        }


        if (!configurationState.configurationLoaded || changed)
        {
            dispatch({
                type: ConfigurationStateActionEnum.SET_CONFIGURATION,
                data: { ...next, configurationLoaded: true }
            });
        }

    }, [searchParams, configurationState])

    return <></>
}

export default ConfigurationUrlParamsHandler;